import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import { Link, useNavigate } from "react-router-dom";

import styles from "../../styles/patient-page-modules/careManagerDashboard.module.css";
import search from "../../assets/images/search.png";
import infoIcon from "../../assets/icons/info-rounded.svg";
import { getDashboardPatients } from "../../services/case-manager/case-manager";
import Spinner from "../../components/spinner";
import Table from "../../components/table";
import Button from "../../components/button-v1";
import Tooltip from "../../components/shared-modules/Tooltip";
import EmptyState from "../../components/EmptyState/EmptyState";
import BillingProgressGroup from "../../components/patient-detail/billing-indicator/BillingProgressGroup";
import { getAllStatuses } from "../../services/admin/statuses";
import { FaPlus } from "react-icons/fa";
import { Bold, Filter } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import { handleApiError } from "../../utils/handleApiError";
import DeviceIconList from "../../components/patient-detail/details-tab/DeviceIconList";
import FilterPanel from "../../components/shared-modules/FilterDrawer/FilterDrawer";
import FilterBuilder from "../../components/shared-modules/filter";
import { applyFilters } from "../../components/shared-modules/filter/utils";
import { formatLastCallDate } from "../../utils/dateFormatters";
import { getLocationList } from "../../services/admin/organization";
import { getAllCaseManagers } from "../../services/admin/case-managers";
import { useQuery, useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { deactivatePatient, getPatientSummary } from "../../services/patient/settings";
import toast from "react-hot-toast";
import useRoles from "../../hooks/useRoles";
import { Dropdown, DropdownItem } from "../../components/ui/dropdown";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../../components/ui/select";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import { formatDate, formatSecondsToTime, displayDate } from "../../utils/helper";
import { LuListFilter } from "react-icons/lu";
import TimeSortDropdown from "../../components/case-manager/TimeSortDropdown";
import BackToTop from "../../components/BackToTop/BackToTop";
import Modal from "../../components/shared-modules/Modal";
import Skeleton from "../../components/super-admin-dashboard/Skeleton";

const dashboardFiltersConfig = [
  // {
  //   label: "First Name",
  //   value: "first_name",
  //   type: "text",
  //   operators: [
  //     "contains",
  //     // "not_equals",
  //     // "contains",
  //     // "not_contains",
  //     // "starts_with",
  //     // "ends_with",
  //     "is_empty",
  //     "is_not_empty",
  //   ],
  // },
  // {
  //   label: "Last Name",
  //   value: "last_name",
  //   type: "text",
  //   operators: [
  //     "contains",
  //     // "not_equals",
  //     // "contains",
  //     // "not_contains",
  //     // "starts_with",
  //     // "ends_with",
  //     "is_empty",
  //     "is_not_empty",
  //   ],
  // },

  {
    label: "patient_name",
    value: "last_name",
    type: "text",
    operators: [
      "contains",
      // "not_equals",
      // "contains",
      // "not_contains",
      // "starts_with",
      // "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },

  // {
  //   label: "Stat  // {
  //   label: "Status",
  //   value: "status",
  //   type: "text",
  //   operators: [
  //     "equals",
  //     // "not_equals",
  //     // "contains",
  //     // "not_contains",
  //     // "starts_with",
  //     // "ends_with",
  //     "is_empty",
  //     "is_not_empty",
  //   ],
  // },us",
  //   value: "status",
  //   type: "text",
  //   operators: [
  //     "equals",
  //     // "not_equals",
  //     // "contains",
  //     // "not_contains",
  //     // "starts_with",
  //     // "ends_with",
  //     "is_empty",
  //     "is_not_empty",
  //   ],
  // },

  {
    label: "Case Manager",
    value: "case_manager_name",
    type: "text",
    operators: [
      "contains",
      // "not_equals",
      // "contains",
      // "not_contains",
      // "starts_with",
      // "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "Provider",
    value: "provider_name",
    type: "text",
    operators: [
      "contains",
      // "not_equals",
      // "contains",
      // "not_contains",
      // "starts_with",
      // "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "Language",
    value: "preferred_language",
    type: "text",
    operators: [
      "contains",
      // "not_equals",
      // "contains",
      // "not_contains",
      // "starts_with",
      // "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "CCM",
    value: "ccm",
    type: "boolean",
    operators: ["is_true", "is_false"],
  },
  {
    label: "RPM",
    value: "rpm",
    type: "boolean",
    operators: ["is_true", "is_false"],
  },
  {
    label: "Reading Days",
    value: "reading_days_current_month",
    type: "number",
    operators: ["equals", "greater_than", "less_than"],
  },
  {
    label: "RPM Time (mins)",
    value: "rpm_time_in_minutes",
    type: "number",
    operators: ["greater_than", "less_than"],
  },
  {
    label: "CCM Time (mins)",
    value: "ccm_time_in_minutes",
    type: "number",
    operators: ["greater_than", "less_than"],
  },
];

const nurseFilterConfig = [
  {
    label: "Careplan Status",
    value: "care_plan_status",
    type: "text",
    operators: ["contains", "is_empty", "is_not_empty"],
  },
];

// care_plan_status

// Debounce a rapidly-changing value (e.g. the search box) so we don't refetch
// the whole paginated list on every keystroke.
function useDebounced(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

const CareManagerDashboard = () => {
  const { roles, position } = useRoles();
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("_pt_tab") || "my_all_patients";
  });
  const [selectedProgram, setselectedProgram] = useState(
    sessionStorage.getItem("selectedProgram") || "all_patients"
  );

  const location_id = JSON.parse(sessionStorage.getItem("current_loc"))?.id;
  // Account-specific column swap (SCRUM-614 for Shaarawy, SCRUM-693 mirrors
  // the same pattern for Shalita): driven by the currently viewed account,
  // not the logged-in user's role, so it's identical for Admin and Care
  // Manager logins. Read fresh each render (same pattern as location_id
  // above) - an account switch invalidates the query cache, which re-renders
  // this component and re-reads sessionStorage.
  const accNameLower = (sessionStorage.getItem("acc_name") || "").toLowerCase();
  const isLastReadingColumnAccount =
    accNameLower.includes("shaarawy") || accNameLower.includes("shalita");
  const is_patient =
    JSON.parse(localStorage.getItem("user"))?.type === "patient" ? true : false;
  const user = JSON.parse(localStorage.getItem("user"));
  const isInactive = selectedProgram === "inactive_patients";
  const [nameSearch, setNameSearch] = useState("");
  const [providerSearch, setProviderSearch] = useState("");
  const navigate = useNavigate();
  const [statuses, setStatuses] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [statusesLoading, setStatusesLoading] = useState(false);
  const [activeWorkflow, setActiveWorkflow] = useState(() => {
    return sessionStorage.getItem("_active_workflow") || "my_all_patients";
  });
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [selectedCaseManager, setSelectedCaseManager] = useState("");
  const [caseManagers, setCaseManagers] = useState([]);
  const [activatingPatientId, setActivatingPatientId] = useState(null);
  const [deactivationReasonModal, setDeactivationReasonModal] = useState({ isOpen: false, reason: "" });
  const queryClient = useQueryClient();

  const {
    data: patientSummary = { active_patients: 0, inactive_patients: 0, compliant_patients: 0 },
    isLoading: patientSummaryLoading,
  } = useQuery(
    ["patientSummary"],
    getPatientSummary,
    { staleTime: 0, cacheTime: 0, refetchOnMount: "always" }
  );

  // Filters sent to the backend as query params. Changing any of these resets
  // pagination and re-walks from page 1 with the new filter. Care Manager and
  // Advance filters intentionally stay client-side for now (their backend ids /
  // operators don't map cleanly yet) and are applied to the accumulated list.
  const debouncedSearch = useDebounced(nameSearch, 400);
  const dashboardParams = useMemo(() => {
    const params = {};
    if (activeTab && activeTab !== "my_all_patients") params.chip = activeTab;
    if (debouncedSearch) params.search = debouncedSearch;
    if (activeFilters.length) params.status = activeFilters;
    if (selectedProgram === "compliant_patients") params.compliant = true;
    else if (selectedProgram === "rpm_patients") params.type = "rpm";
    else if (selectedProgram === "ccm_patients") params.type = "ccm";
    return params;
  }, [activeTab, debouncedSearch, activeFilters, selectedProgram]);

  // Silent background pagination: page 1 renders the dashboard, then the effect
  // below keeps fetching the next page until the whole (server-filtered) list is
  // accumulated. No pagination UI. If the backend doesn't paginate this response
  // (no `meta`), getNextPageParam returns undefined and this behaves exactly like
  // the old single full-list call. (A filter change keeps the current rows on
  // screen via the manual prev-data ref below, so there's no spinner flash.)
  const {
    data: patientsInfinite,
    isLoading: loading,
    error: fetchError,
    refetch: refetchPatients,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ["dashboardPatients", isInactive, dashboardParams],
    ({ pageParam = 1 }) =>
      getDashboardPatients({
        locationId: location_id,
        staffId: user?.staff_id,
        isCaseManager: roles.includes("Case Manager"),
        isInactive,
        page: pageParam,
        pageSize: 50,
        ...dashboardParams,
      }),
    {
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => {
        const meta = lastPage?.meta;
        if (meta && meta.current_page < meta.total_pages) {
          return meta.current_page + 1;
        }
        return undefined;
      },
    }
  );

  // Walk every remaining page in the background as soon as the previous one lands.
  // If a page ultimately fails (after react-query's retries) the query's `error`
  // is set while the rows loaded so far are kept; we gate the auto-advance on that
  // error so we never loop the failing request. A successful retry / filter change
  // clears the error and resumes from the page that stopped.
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage && !fetchError) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage, fetchError]);

  // A *background* page failed when the query has an error but page 1 already
  // loaded and more pages remain. (An initial-load failure has no data and is
  // handled by the table's error empty state instead.)
  const partialLoadFailed =
    !!fetchError &&
    !loading &&
    hasNextPage &&
    !!patientsInfinite?.pages?.length;

  // Background pagination is silent. The only thing the user ever sees is one
  // persistent toast if a page fails, with a Retry that resumes from where it
  // stopped. It clears itself when the load recovers or the filters change, and
  // never shifts the page layout.
  useEffect(() => {
    const id = "dashboard-partial-load";
    if (partialLoadFailed) {
      toast.error(
        () => (
          <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            Some patients didn&rsquo;t load.
            <button
              type="button"
              onClick={() => fetchNextPage()}
              style={{
                background: "none",
                border: "none",
                color: "#48A6C4",
                fontWeight: 600,
                cursor: "pointer",
                padding: 0,
                font: "inherit",
              }}
            >
              Retry
            </button>
          </span>
        ),
        { id, duration: Infinity }
      );
    } else {
      toast.dismiss(id);
    }
  }, [partialLoadFailed, fetchNextPage]);

  // Flatten the accumulated pages back into the { patients: [...] } shape the rest
  // of the dashboard already consumes, and surface the server chip_counts + meta.
  const freshPatients = useMemo(() => {
    const pages = patientsInfinite?.pages || [];
    if (!pages.length) return null;
    const allPatients = pages.flatMap(
      (p) => p?.patients || p?.assigned_patients || []
    );
    const first = pages[0] || {};
    const last = pages[pages.length - 1] || {};
    return {
      ...first,
      patients: allPatients,
      chip_counts: first.chip_counts,
      meta: last.meta,
    };
  }, [patientsInfinite]);

  // Manual "keep previous data": hold the last good result so a filter change
  // keeps the current rows on screen while the new query loads. (react-query's
  // own keepPreviousData breaks fetchNextPage in v4's useInfiniteQuery.) The ref
  // is updated in an effect, NOT during render, so it never interferes with the
  // query observer / fetchNextPage.
  const prevPatientsRef = useRef({});
  useEffect(() => {
    if (freshPatients) prevPatientsRef.current = freshPatients;
  }, [freshPatients]);
  const patients = freshPatients || prevPatientsRef.current;

  // Full-page spinner only on the very first load; later filter changes keep the
  // dashboard chrome and show a lighter in-table loading state.
  const everLoadedRef = useRef(false);
  useEffect(() => {
    if (freshPatients?.patients?.length) everLoadedRef.current = true;
  }, [freshPatients]);
  const showInitialSpinner = loading && !everLoadedRef.current;


  const activatePatientMutation = useMutation(
    ({ patientId, body }) => deactivatePatient({ patientId, body }),
    {
      onSuccess: () => {
        toast.success("Patient activated successfully.");
        setActivatingPatientId(null);
        queryClient.invalidateQueries(["patientSummary"]);
        queryClient.invalidateQueries(["dashboardPatients"]);
      },
      onError: () => {
        toast.error("Could not activate patient.");
        setActivatingPatientId(null);
      },
    }
  );

  useEffect(() => {
    getAllCaseManagers()
      .then((data) => setCaseManagers(Array.isArray(data) ? data : []))
      .catch(() => setCaseManagers([]));
      console.log("Testing")//  Remove this console after testing new stage
  }, []);

  // GENERAL FILTER
  const [filters, setFilters] = useState([]);

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const isOutOfRange = (patient) => {
    return patient.out_of_range === true;
  };

  const isMonitoringSessionWorkflow = (patient) => {
    return patient.monitoring_session === true;
  };

  const isUnseenReadings = (patient) => {
    return patient.unseen_readings === true;
  };

  const isReadingReminder = (patient) => {
    return patient.reading_reminder === true;
  };

  const handleProgramSelect = (program) => {
    setselectedProgram(program);
    sessionStorage.setItem("selectedProgram", program);
  };
  //just for testing ui
  const sampleRPM = {
    reading_days_current_month: 1,
    has_two_way_communication: true,
    rpm_time_in_minutes: 35,
  };
  const sampleCCM = {
    has_two_way_communication: true,
    care_plan_created: true,
    care_plan_finalized: false,
    ccm_time_in_minutes: 50,
  };

  // FILTERS
  let filterConfig = dashboardFiltersConfig;

  const workflows = [
    {
      id: "out_of_range",
      label: "Out of Range",
      tooltip:
        "Patient that have unresolved out of range readings. Address by resolving any out of range readings on these patients.",
      filterFunction: isOutOfRange,
    },
    {
      id: "monitoring_session",
      label: "Monitoring Session",
      tooltip:
        "It has been at least 2 days since time was monitored and these patients have less than 20 minutes logged. Address by spending time Conviewing these patients' 87 readings & data.",
      filterFunction: isMonitoringSessionWorkflow,
    },
    {
      id: "unseen_readings",
      label: "Unseen Readings",
      tooltip:
        "Patients that have unseen readings.Address by logging any amount of monitoring time for these patients. View their new reading",
      filterFunction: isUnseenReadings,
    },
    {
      id: "reading_reminder",
      label: "Reading Reminder",
      tooltip:
        "Patients who are off track and have not receive a reading in the last 3 days. Address by logging some sort of communication with each patient.",
      filterFunction: isReadingReminder,
    },
  ];

  // Chip badge counts come straight from the backend (chip_counts), computed over
  // the filtered set excluding the active chip so they stay stable as the user
  // switches chips. No longer counted from the (now paginated) client list.
  const workflowData = useMemo(() => {
    const counts = patients?.chip_counts || {};
    const data = {};
    workflows.forEach((workflow) => {
      data[workflow.id] = { count: counts[workflow.id] ?? 0 };
    });
    return data;
  }, [patients]);

  const handlePatientClick = (patient) => {
    sessionStorage.removeItem("tab-selected");
    sessionStorage.setItem("_pt_id", patient.id);
    const ccm = Number(patient.ccm);
    const rpm = Number(patient.rpm);

    const patientListForCache =
      patients?.patients || patients?.assigned_patients || [];
    const latestCallMap = {};
    patientListForCache.forEach((p) => {
      if (p?.id) latestCallMap[p.id] = p.latest_call || null;
    });
    sessionStorage.setItem("_pts_latest_calls", JSON.stringify(latestCallMap));

    sessionStorage.setItem("_dash", "case_manager");
    navigate(
      `/patient/details/?patient_id=${patient.id}&CCM=${ccm}&RPM=${rpm}`
    );
  };

  useEffect(() => {
    const fetchStatuses = async () => {
      setStatusesLoading(true);
      try {
        const statusData = await getAllStatuses();
        setStatuses(statusData || []);
      } catch (error) {
        handleApiError(error);
      } finally {
        setStatusesLoading(false);
      }
    };

    fetchStatuses();
  }, []);

  const filteredData = useMemo(() => {
    let list = patients?.patients || patients?.assigned_patients || [];

    // The backend already applied chip / search / status / program filters and
    // returned the (paginated, then accumulated) result. Inactive view: guard
    // client-side in case the endpoint mixes in active rows.
    if (selectedProgram === "inactive_patients") {
      list = list.filter((patient) => !patient.is_active);
    }

    // Serialize the display-only fields the table columns + the remaining
    // client-side filters need.
    list.forEach((patient) => {
      if (patient.case_manager && typeof patient.case_manager === "object") {
        const first = patient.case_manager.first_name || "";
        const last = patient.case_manager.last_name || "";
        patient.case_manager_name = `${first} ${last}`.trim();
      } else {
        patient.case_manager_name = "";
      }

      patient.patient_name =
        `${patient.first_name || ""} ${patient.last_name || ""}`.trim();

      if (patient.provider && typeof patient.provider === "object") {
        const first = patient.provider.first_name || "";
        const last = patient.provider.last_name || "";
        patient.provider_name = `${first} ${last}`.trim();
      } else {
        patient.provider_name = "";
      }

      patient.ccm_time_in_minutes = Math.floor(
        (Number(patient.total_ccm_seconds) || 0) / 60
      );
      patient.rpm_time_in_minutes = Math.floor(
        (Number(patient.total_rpm_seconds) || 0) / 60
      );
    });

    // Care Manager + Advance filters still run client-side on the accumulated
    // list (correct because we hold the full server-filtered set, not one page).
    const afterCaseManagerFilter = selectedCaseManager
      ? list.filter((p) => p.case_manager_name === selectedCaseManager)
      : list;

    return applyFilters(afterCaseManagerFilter, filters);
  }, [patients, selectedProgram, selectedCaseManager, filters]);

  const caseManagerOptions = useMemo(() => {
    return caseManagers
      .map((cm) => `${cm.first_name || ""} ${cm.last_name || ""}`.trim())
      .filter(Boolean)
      .sort();
  }, [caseManagers]);

  const handleFilterClick = (statusId) => {
    if (activeFilters.includes(statusId)) {
      setActiveFilters(activeFilters.filter((id) => id !== statusId));
    } else {
      setActiveFilters([...activeFilters, statusId]);
    }
  };

  const handleClearFilters = () => {
    setActiveFilters([]);
    setSelectedCaseManager("");
  };

  const handleSeeMoreClick = (e, reason) => {
    e.stopPropagation();
    setDeactivationReasonModal({ isOpen: true, reason });
  };

  const getCaseManagerName = (caseManager) => {
    if (!caseManager) return "--";
    return `${caseManager.first_name} ${caseManager.last_name}`;
  };
  const mapIndicatorTo3Segments = (indicator) => {
    if (!indicator?.segments) return [];

    const { segments } = indicator;

    const timeBasedCompleted =
      segments.time_based?.sub_segments &&
      Object.values(segments.time_based.sub_segments).some(Boolean);

    return [
      Boolean(
        segments.device_readings?.completed ||
        segments.care_plan_documented?.completed
      ),
      Boolean(
        segments.two_way_communication?.completed ||
        segments.care_plan_finalized?.completed
      ),
      Boolean(timeBasedCompleted),
    ];
  };

  const getProviderName = (provider) => {
    if (!provider) return "--";
    return `${provider.first_name} ${provider.last_name}`;
  };

  const getLastReading = (reading) => {
    if (reading === null || reading === undefined) return "--";
    if (reading === 0) {
      return <span style={{ color: "#63c132" }}>Today</span>;
    }
    if (reading === 1) {
      return <span style={{ color: "#63c132" }}>Yesterday</span>;
    }
    return `${reading} days ago`;
  };

  // SCRUM-614/SCRUM-693: Shaarawy and Shalita see Last Reading (reusing the
  // same day-count convention as the Engagement column's "Last Reading"
  // line via getLastReading) in place of Case Manager. Same array position
  // for both, so column order/sort for every other column is unaffected.
  const caseManagerOrLastReadingColumn = isLastReadingColumnAccount
    ? {
        key: "last_reading",
        label: "Last Reading",
        alignLeft: true,
        sorting: true,
        customSort: (a, b, direction) => {
          const aLast = a.days_since_last_reading ?? Infinity;
          const bLast = b.days_since_last_reading ?? Infinity;
          if (aLast === bLast) return 0;
          return direction === "asc" ? aLast - bLast : bLast - aLast;
        },
        render: (row) => getLastReading(row.days_since_last_reading),
      }
    : {
        key: "case_manager_name",
        label: "Case Manager",
        // render: (row) => getCaseManagerName(row.case_manager),
        alignLeft: true,
      };

  const patientTableColumns = [
     {
      key: "name",
      label: "Name",
      sorting: true,
      alignLeft: true,
      sortField: "last_name",
      render: (row) => (
        <div className={styles.nameWithDevices}>
          <span className={styles.patientName}>
            {row.first_name} {row.last_name}
          </span>
          <DeviceIconList devices={row.devices} size="small" />
        </div>
      ),
     },
    {
      key: "program",
      label: "Program",
      alignLeft: true,
      sorting: false,
      render: (row) => (
        <BillingProgressGroup
          rpm={row.rpm_ccm_indicator?.rpm_indicator}
          ccm={row.rpm_ccm_indicator?.ccm_indicator}
          isLight={false}
        />
      ),
    },
    {
      key: "statuses",
      label: "Statuses",
      alignLeft: true,
      render: (row) => {
        if (!row.statuses || row.statuses.length === 0) {
          return "_ _";
        }

        return (
          <div className={styles.patient_status_container}>
            {row.statuses
              .filter(
                (status) =>
                  status.status !== "voice-mail" &&
                  status.status !== "two-way-communication"
              )
              .map((status, index) => {
                let customStyle = {};
                if (status.status === "voice-mail") {
                  customStyle = {
                    backgroundColor: "#f9f1d9",
                    borderColor: "#f9f1d9",
                  };
                } else if (status.status === "two-way-communication") {
                  customStyle = {
                    backgroundColor: "#d4eee0",
                    borderColor: "#d4eee0",
                  };
                }

                return (
                  <div
                    key={index}
                    className={
                      status.is_default
                        ? styles.patient_default_status
                        : styles.patient_status_item
                    }
                    style={customStyle}
                  >
                    <span className={styles.patient_status_tag}>
                      {status.status}
                      {status.status === "voice-mail" && status.voicemail_count
                        ? ` (${status.voicemail_count}x)`
                        : ""}
                      {status.status === "two-way-communication" &&
                        status.TWC_count
                        ? ` (${status.TWC_count}x)`
                        : ""}
                      {status.description && (
                        <Tooltip content={status.description} position="right">
                          <img
                            src={infoIcon}
                            className={styles.status_icon}
                            alt="info"
                          />
                        </Tooltip>
                      )}
                    </span>
                  </div>
                );
              })}
          </div>
        );
      },
    },
    caseManagerOrLastReadingColumn,
    {
      key: "provider",
      label: "Provider",
      render: (row) => getProviderName(row.provider),
      alignLeft: true,
    },
    // {
    //   key: "patient_location",
    //   label: "Location",
    //   render: (row) => row.patient_location,
    //   alignLeft: true,
    // },
    {
      key: "prefered_lenguage",
      label: "Language",
      render: (row) => row.preferred_language,
      alignLeft: true,
    },
    {
      key: "time_column",
      label: "Time (hr:mm:ss)",
      alignLeft: true,
      sorting: true,
      render: (row) => {
        const toHMS = (secs) => {
          const s = Number(secs) || 0;
          const h = Math.floor(s / 3600);
          const m = Math.floor((s % 3600) / 60);
          const sec = s % 60;
          return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
        };

        return (
          <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
            <strong>RPM</strong> {toHMS(row.total_rpm_seconds)}
            <span style={{ margin: "0 6px", color: "black", fontWeight: "bold" }}>|</span>
            <strong>CCM</strong> {toHMS(row.total_ccm_seconds)}
          </span>
        );
      },
      customHeader: (props) => <TimeSortDropdown {...props} />,
      customSort: (a, b, direction, extra) => {
        const sortType = extra?.type || "rpm";
        const sortKey =
          sortType === "ccm"
            ? "total_ccm_seconds"
            : "total_rpm_seconds";

        const aValue = Number(a[sortKey]) || 0;
        const bValue = Number(b[sortKey]) || 0;

        if (aValue === bValue) return 0;
        return direction === "asc" ? aValue - bValue : bValue - aValue;
      },
    },
    // {
    //   key: "careplan_status",
    //   label: "Careplan Status",
    //   alignLeft: true,
    //   sorting: true,
    //   render: (row) => row.careplan_status === "in_progress" ? "In Progress" :
    //     row.careplan_status === "finalized" ? "Finalized" :
    //       row.careplan_status === "completed" ? "Completed" :
    //         "--" || "--",
    // },
    {
      key: "reading_days_current_month",
      label: "Engagement",
      alignLeft: true,
      sorting: true,
      // Primary: reading days (nulls last in both directions, matching the
      // table's default null handling). Tie-break: most recent reading first
      // (days_since_last_reading ascending), never-read last.
      customSort: (a, b, direction) => {
        // ?? null: an absent field and an explicit null must compare equal
        // (strict !== below would otherwise subtract null - undefined = NaN)
        const aDays = a.reading_days_current_month ?? null;
        const bDays = b.reading_days_current_month ?? null;
        if (aDays == null && bDays != null) return 1;
        if (bDays == null && aDays != null) return -1;
        if (aDays !== bDays) {
          return direction === "asc" ? aDays - bDays : bDays - aDays;
        }
        const aLast = a.days_since_last_reading ?? Infinity;
        const bLast = b.days_since_last_reading ?? Infinity;
        if (aLast === bLast) return 0; // both-Infinity would yield NaN
        return aLast - bLast;
      },
      render: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "2px", fontSize: "13px" }}>
          <span>Reading days: <strong>{row.reading_days_current_month ?? "--"}</strong></span>
          {/* SCRUM-614/SCRUM-693: Shaarawy and Shalita already have a
              dedicated Last Reading column, so this line would be a
              duplicate there. */}
          {!isLastReadingColumnAccount && (
            <span>Last Reading: <strong>{getLastReading(row.days_since_last_reading)}</strong></span>
          )}
        </div>
      ),
    },
    {
      key: "latest_call",
      label: "Last Call",
      alignLeft: true,
      sorting: true,
      render: (row) => {
        if (!row.latest_call) {
          return "_ _";
        }

        const commStatus = row.statuses?.find(
          (s) =>
            s.status === "two-way-communication" ||
            s.status === "voice-mail"
        );

        let label = "";
        let count = "";
        let bgColor = "#eee";
        let textColor = "#333";

        if (commStatus?.status === "two-way-communication") {
          label = "Two-Way ";
          count = commStatus.TWC_count ? ` (${commStatus.TWC_count}x)` : "";
          bgColor = "#D4EEE0";
          textColor = "#1A5D3D";
        }

        if (commStatus?.status === "voice-mail") {
          label = "Voicemail";
          count = commStatus.voicemail_count
            ? ` (${commStatus.voicemail_count}x)`
            : "";
          bgColor = "#F9F1D9";
          textColor = "#7E6513";
        }

        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {label && (
              <span
                style={{
                  backgroundColor: bgColor,
                  color: textColor,
                  padding: "4px 10px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  fontWeight: 500,
                  width: "fit-content",
                }}
              >
                {label}
                {count}
              </span>
            )}

            <span>{formatLastCallDate(row.latest_call)}</span>
          </div>
        );
      },

    },
    // {
    //   key: "device_status",
    //   label: "Device Status",
    //   sorting: false,
    //   alignLeft: true,
    //   render: (row) => {
    //     const status = row.device_status;

    //     const getStyle = (status) => {
    //       const baseStyle = {
    //         padding: "4px 12px",
    //         borderRadius: "25px",
    //         textAlign: "center",
    //         display: "inline-flex",
    //         alignItems: "center",
    //         gap: "10px",
    //         justifyContent: "center",
    //         fontSize: "14px",
    //         fontWeight: "500",
    //       };

    //       if (status === "Assigned") {
    //         return {
    //           ...baseStyle,
    //           backgroundColor: "#D4EEE0",
    //           color: "#1A5D3D",
    //         };
    //       } else if (status === "Needs readings") {
    //         return {
    //           ...baseStyle,
    //           backgroundColor: "#B6DAFC",
    //           color: "#1B4F72",
    //         };
    //       } else if (status === "None") {
    //         return {
    //           ...baseStyle,
    //           backgroundColor: "#F9F1D9",
    //           color: "#7E6513",
    //         };
    //       }
    //       return { ...baseStyle, backgroundColor: "#eee", color: "#333" };
    //     };

    //     const getDotColor = (status) => {
    //       if (status === "Assigned") return "#178D5A";
    //       if (status === "Needs readings") return "#2874A6";
    //       if (status === "None") return "#B7950B";
    //       return "#666";
    //     };

    //     return (
    //       <>
    //         {row.ccm === true && row.rpm === false ? (
    //           <span>--</span>
    //         ) : (
    //           <span style={getStyle(status)}>
    //             <span
    //               style={{
    //                 width: "8px",
    //                 height: "8px",
    //                 backgroundColor: getDotColor(status),
    //                 borderRadius: "50%",
    //               }}
    //             ></span>
    //             <span>{status}</span>
    //           </span>
    //         )}
    //       </>
    //     );
    //   },
    // },
    // {
    //   key: "program",
    //   label: "Program",
    //   render: (row) =>
    //     row.rpm && row.ccm
    //       ? "RPM | CCM"
    //       : row.rpm
    //         ? "RPM"
    //         : row.ccm
    //           ? "CCM"
    //           : "None",
    // },
  ];

  const nurseTabColumns = [
    {
      key: "careplan_status",
      label: "Careplan Status",
      alignLeft: true,
      render: (row) => {
        if (!row.care_plan_status) {
          return "_ _";
        }

        return (
          <div className={styles.patient_status_container}>
            <div
              // className={
              //   status.is_default
              //     ? styles.patient_default_status
              //     : styles.patient_status_item
              // }
              className={styles.patient_status_item}
            >
              <span className={styles.patient_status_tag}>
                {/* {status.status} */}
                {/* {status.description && (
                    <Tooltip content={status.description} position="right">
                      <span className={styles.status_icon}>?</span>
                    </Tooltip>
                  )} */}
                {row.care_plan_status}
              </span>
            </div>
          </div>
        );
      },
    },
    // {
    //   key: "assigned_date",
    //   label: "Assigned Date",
    //   render: (row) => formatDate(row.careplan_assigned_date),
    //   alignLeft: true,
    // },
  ];

  let tableColumns = patientTableColumns;

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    sessionStorage.setItem("_pt_tab", tabId);
    sessionStorage.setItem("_active_workflow", tabId);

    if (tabId === "my_all_patients") {
      sessionStorage.setItem("_workflow_name", "All Patients");
    } else {
      const workflow = workflows.find((w) => w.id === tabId);
      sessionStorage.setItem(
        "_workflow_name",
        workflow?.label || "Unknown Workflow"
      );
    }
  };

  const getWorkflowAwareMetrics = useMemo(() => {
    const allPatients = patients?.patients || patients?.assigned_patients || [];
    const filteredPatients = allPatients;
    const isInactive = selectedProgram === "inactive_patients";

    return {
      totalPatients:
        (filteredPatients?.length ?? 0) +
        (patients?.deactivated_patient_count ?? 0),
      rpmPatients: filteredPatients.filter((patient) => patient.rpm).length,
      ccmPatients: filteredPatients.filter((patient) => patient.ccm).length,
      compliantPatients: filteredPatients.filter((patient) => patient.is_compliant).length,
      newPatients: filteredPatients.filter((patient) => {
        const createdDate = patient.created_at
          ? new Date(patient.created_at)
          : null;
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        return createdDate && createdDate > thirtyDaysAgo;
      }).length,
      pendingCareplans: patients?.total_pending_care_plans,
      finalizedCareplans: patients?.total_finalized_care_plans,
      deactivated_patient_count: patients?.deactivated_patient_count ?? 0,
      active_patient_count: isInactive
        ? 0
        : (filteredPatients?.length ?? 0),
    };
  }, [patients, selectedProgram]);

  const getWorkflowCompletionPercentages = useMemo(() => {
    // Totals come from the backend chip_counts (over the full filtered set), not
    // the page slice the client currently holds.
    const counts = patients?.chip_counts || {};
    const totalPatients = counts.all_patients || 0;

    if (totalPatients === 0) return {};

    const percentages = {};

    workflows.forEach((workflow) => {
      const workflowPatients = counts[workflow.id] || 0;
      const completedPatients = totalPatients - workflowPatients;
      const completionPercentage = Math.round(
        (completedPatients / totalPatients) * 100
      );

      percentages[workflow.id] = {
        completed: completedPatients,
        total: totalPatients,
        percentage: completionPercentage,
      };
    });

    return percentages;
  }, [patients]);

  const inactivePatientColumns = [
    {
      key: "name",
      label: "Name",
      sorting: true,
      alignLeft: true,
      sortField: "last_name",
      render: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <span>{`${row.first_name} ${row.last_name}`}</span>
          <span style={{ color: "#6b7280", fontSize: "12px" }}>
            {row.dob || "--"}
          </span>
        </div>
      ),
    },
    {
      key: "program",
      label: "Program",
      alignLeft: true,
      render: (row) =>
        [row.rpm && "RPM", row.ccm && "CCM"].filter(Boolean).join(" | ") || "--",
    },
    {
      key: "phone",
      label: "Phone Number",
      alignLeft: true,
      render: (row) => row.primary_phone || "--",
    },
    {
      key: "deactivation_reason",
      label: "Deactivate Reason",
      alignLeft: true,
      render: (row) => {
        const reason = row.deactivation_reason;
        if (!reason) return <span>--</span>;
        const isLong = reason.length > 60;
        return (
          <div className={styles.deactivation_reason_cell}>
            <span className={styles.deactivation_reason_text}>
              {isLong ? `${reason.slice(0, 60)}...` : reason}
            </span>
            {isLong && (
              <button
                className={styles.see_more_btn}
                onClick={(e) => handleSeeMoreClick(e, reason)}
              >
                See More
              </button>
            )}
          </div>
        );
      },
    },
    {
      key: "discarded_at",
      label: "Discarded At",
      alignLeft: true,
      render: (row) => formatDate(row.discarded_at),
    },
    {
      key: "action",
      label: "Action",
      alignLeft: true,
      render: (row) => (
        <button
          disabled={activatingPatientId === row.id}
          style={{
            padding: "4px 12px",
            backgroundColor: activatingPatientId === row.id ? "#a0c8d8" : "#48A6C4",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: activatingPatientId === row.id ? "not-allowed" : "pointer",
            fontSize: "12px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setActivatingPatientId(row.id);
            activatePatientMutation.mutate({
              patientId: row.id,
              body: { user: { is_active: true, deactivation_reason: "" } },
            });
          }}
        >
          {activatingPatientId === row.id ? "Activating..." : "Activate"}
        </button>
      ),
    },
  ];

  return (
    <div className={styles.patient_page}>
      <div className={styles.patient_page_container}>
        {!is_patient && (
          <>
            {showInitialSpinner ? (
              <>
                <Spinner />
              </>
            ) : (
              <>
                {/* Dashboard Metrics */}

                <div className={styles.dashboard_wrapper}>
                  <div
                    className={styles.dash_item}
                    onClick={() => handleProgramSelect("active_patients")}
                    style={{
                      border:
                        selectedProgram === "active_patients"
                          ? "2px solid var(--primary)"
                          : "",
                      backgroundColor:
                        selectedProgram === "active_patients" ? "#ffffff" : "",
                    }}
                  >
                    <p className={styles.heading}>Active Patients</p>
                    <p className={styles.quantity}>
                      {patientSummaryLoading ? (
                        <Skeleton width="52px" height="28px" radius="8px" />
                      ) : (
                        patientSummary.active_patients
                      )}
                    </p>
                  </div>

                  {/* <div
                        className={styles.dash_item}
                        onClick={() => handleProgramSelect("all_patients")}
                        style={{
                          border:
                            selectedProgram === "all_patients"
                              ? "2px solid var(--primary)"
                              : "",
                          backgroundColor:
                            selectedProgram === "all_patients" ? "#E9F5FF" : "",
                        }}
                      >
                        <p className={styles.heading}>Total Patients</p>
                        <p className={styles.quantity}>
                          {getWorkflowAwareMetrics.totalPatients}
                        </p>
                      </div> */}

                  {/* <div
                    className={styles.dash_item}
                    onClick={() => handleProgramSelect("rpm_patients")}
                    style={{
                      border:
                        selectedProgram === "rpm_patients"
                          ? "2px solid var(--primary)"
                          : "",
                      backgroundColor:
                        selectedProgram === "rpm_patients" ? "#E9F5FF" : "",
                    }}
                  >
                    <p className={styles.heading}>RPM Patients</p>
                    <p className={styles.quantity}>
                      {getWorkflowAwareMetrics.rpmPatients}
                    </p>
                  </div>
                  <div
                    className={styles.dash_item}
                    onClick={() => handleProgramSelect("ccm_patients")}
                    style={{
                      border:
                        selectedProgram === "ccm_patients"
                          ? "2px solid var(--primary)"
                          : "",
                      backgroundColor:
                        selectedProgram === "ccm_patients" ? "#E9F5FF" : "",
                    }}
                  >
                    <p className={styles.heading}>CCM Patients</p>
                    <p className={styles.quantity}>
                      {getWorkflowAwareMetrics.ccmPatients}
                    </p>
                  </div> */}

                  <div
                    onClick={() => handleProgramSelect("compliant_patients")}
                    style={{
                      border:
                        selectedProgram === "compliant_patients"
                          ? "2px solid var(--primary)"
                          : "",
                      backgroundColor:
                        selectedProgram === "compliant_patients"
                          ? "#ffffff"
                          : "",
                    }}
                    className={styles.dash_item}
                  >
                    <p className={styles.heading}>Compliant Patients</p>
                    <p className={styles.quantity}>
                      {patientSummaryLoading ? (
                        <Skeleton width="52px" height="28px" radius="8px" />
                      ) : (
                        patientSummary.compliant_patients
                      )}
                    </p>
                  </div>

                  {/* <div
                    className={styles.dash_KPI}
                  onClick={() => handleProgramSelect("all_patients")}
                  style={{
                    border:
                      selectedProgram === "all_patients"
                        ? "2px solid var(--primary)"
                        : "",
                    backgroundColor:
                      selectedProgram === "all_patients" ? "#E9F5FF" : "",
                  }}
                  >
                    <p className={styles.heading}>Total Patients</p>
                    <p className={styles.quantity}>
                      {getWorkflowAwareMetrics.totalPatients}
                    </p>
                  </div> */}

                  <div
                    className={styles.dash_KPI}
                  onClick={() => handleProgramSelect("inactive_patients")}
                  style={{
                    border:
                      selectedProgram === "inactive_patients"
                        ? "2px solid var(--primary)"
                        : "",
                    backgroundColor:
                      selectedProgram === "inactive_patients" ? "#ffffff" : "",
                  }}
                  >
                    <p className={styles.heading}>In-Active Patients</p>
                    <p className={styles.quantity}>
                      {patientSummaryLoading ? (
                        <Skeleton width="52px" height="28px" radius="8px" />
                      ) : (
                        patientSummary.inactive_patients
                      )}
                    </p>
                  </div>
                </div>

                {/* Patient Table Section */}
                <div className={styles.patient_wrapper}>
                  {/* Workflow Tabs + Add Patient — hidden on inactive */}
                  {selectedProgram !== "inactive_patients" && (
                  <div className={styles.toggle_wrapper} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
                      <p
                        className={`${styles.patient_toggle} ${activeTab === "my_all_patients" ? styles.active : ""
                          }`}
                        onClick={() => handleTabChange("my_all_patients")}
                      >
                        All Patients ({patients?.chip_counts?.all_patients ?? 0})
                      </p>

                      {workflows.map((workflow) => (
                        <div key={workflow.id}>
                          <p
                            className={`${styles.patient_toggle} ${activeTab === workflow.id ? styles.active : ""
                              }`}
                            onClick={() => handleTabChange(workflow.id)}
                          >
                            {workflow.label} (
                            {workflowData[workflow.id]?.count || 0})
                            <Tooltip content={workflow.tooltip} position="top">
                              <img
                                src={infoIcon}
                                className={styles.info_icon}
                                alt="info"
                              />
                            </Tooltip>
                          </p>
                        </div>
                      ))}
                    </div>

                    {!roles.includes("Case Manager") && (
                      <Link
                        to={location_id && "/patient/create-patient"}
                        className={styles.top_btn}
                        style={{ flexShrink: 0 }}
                      >
                        <Button variant="primary" size="default">
                          <FaPlus size="10px" />
                          Add Patient
                        </Button>
                      </Link>
                    )}
                  </div>
                  )}

                  {/* Table Container — active / workflow tabs */}
                  {selectedProgram !== "inactive_patients" && (activeTab === "my_all_patients" ||
                    workflows.some((w) => w.id === activeTab)) && (
                      <div className={styles.table_container}>
                        {/* Search and Filter Controls */}
                        <div
                          className={styles.searchbar_container}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                              alignItems: "center",
                            }}
                          >
                            <div className={styles.input_wrapper}>
                              <input
                                type="text"
                                placeholder="Search "
                                value={nameSearch}
                                onChange={(e) => setNameSearch(e.target.value)}
                              />
                              <img alt=" " src={search || "/placeholder.svg"} />
                            </div>

                            {/* CASE MANAGER FILTER */}
                            <div style={{ minWidth: "180px" }}>
                              <Select
                              
                                value={selectedCaseManager}
                                onChange={(val) => setSelectedCaseManager(val === selectedCaseManager ? "" : val)}
                              >
                                 <SelectTrigger style={{backgroundColor: "#f8fafd",borderColor:"#c9cbd5",padding:"10px"}}>
                                  <SelectValue placeholder="Care Managers" />
                                </SelectTrigger>
                                <SelectContent>
                                  {selectedCaseManager && (
                                    <SelectItem value="">
                                      All Case Managers
                                    </SelectItem>
                                  )}
                                  {caseManagerOptions.map((name) => (
                                    <SelectItem key={name} value={name}>
                                      {name}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </div>

                            <div style={{ position: "relative" }}>
                            <button
                              type="button"
                              className={`${styles.filter_trigger_button} ${activeFilters.length > 0 ? styles.active : ""}`}
                              onMouseDown={(e) => e.stopPropagation()}
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsFilterPanelOpen((prev) => !prev);
                              }}
                            >
                             
                              Status Filters
                              {activeFilters.length > 0 && (
                                <span
                                  style={{
                                    backgroundColor: "var(--primary)",
                                    color: "#DBEAF8",
                                    borderRadius: "10px",
                                    padding: "4px 4px",
                                    fontSize: "10px",
                                    minWidth: "18px",
                                    textAlign: "center",
                                  }}
                                >
                                  {activeFilters.length}
                                </span>
                                
                              )}
                               <LuListFilter  size={14} />
                            </button>

                            <FilterPanel
                              isOpen={isFilterPanelOpen}
                              onToggle={() =>
                                setIsFilterPanelOpen((prev) => !prev)
                              }
                              statuses={statuses}
                              activeFilters={activeFilters}
                              onFilterChange={handleFilterClick}
                              onApplyFilters={(filters) => setActiveFilters(filters)}
                              filteredData={filteredData}
                              statusesLoading={statusesLoading}
                              variant="dropdown"
                            />
                            </div>

                            {/* GENERAL FILTER */}
                            <Popover>
                              <PopoverTrigger asChild>
                                <button
                                  className={`${styles.filter_trigger_button} ${activeFilters.length > 0 ? styles.active : ""
                                    }`}
                                >
                                  
                                  Advance Filters
                                  {filters.length > 0 && (
                                    <span
                                      style={{
                                        backgroundColor: "var(--primary)",
                                        color: "#DBEAF8",
                                        borderRadius: "10px",
                                        padding: "4px 4px",
                                        fontSize: "10px",
                                        minWidth: "18px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {filters.length}
                                    </span>
                                  )}
                                  <LuListFilter  size={14} />
                                </button>
                              </PopoverTrigger>
                              <PopoverContent
                                sideOffset={5}
                                defaultCloseBtn
                                align="center"
                                className={styles.filter_container}
                              >
                                <FilterBuilder
                                  fieldConfig={filterConfig}
                                  initialFilters={filters}
                                  onChange={handleFiltersChange}
                                />
                              </PopoverContent>
                            </Popover>

                            {activeFilters.length > 0 && (
                              <button
                                className={styles.clear_all_button}
                                onClick={handleClearFilters}
                              >
                                Clear All
                              </button>
                            )}
                          </div>

                          {activeTab !== "my_all_patients" &&
                            getWorkflowCompletionPercentages[activeTab] && (
                              <div
                                className={styles.workflow_completion_display}
                                style={{
                                  minWidth: "300px",
                                }}
                              >
                                <div style={{ marginBottom: "8px" }}>
                                  <span
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: "700",
                                      color: "#1a1a1a",
                                      marginRight: "8px",
                                    }}
                                  >
                                    {
                                      getWorkflowCompletionPercentages[activeTab]
                                        .percentage
                                    }
                                    %
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      color: "#1a1a1a",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {
                                      workflows.find((w) => w.id === activeTab)
                                        ?.label
                                    }{" "}
                                    Completed
                                  </span>
                                </div>

                                <div
                                  style={{
                                    width: "100%",
                                    height: "10px",
                                    backgroundColor: "#e0e0e0",
                                    borderRadius: "6px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: `${getWorkflowCompletionPercentages[activeTab].percentage}%`,
                                      height: "100%",
                                      backgroundColor: "#10164D",
                                      borderRadius: "4px",
                                      transition: "width 0.3s ease",
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>



                

                        <div
                          className={`${styles.all_patients} ${styles.activeTable}`}
                        >
                          {(() => {
                            // Server-side filtering: an empty result means either
                            // "no patients on this location" (no filters) or "no
                            // matches" (a chip/search/status/filter is active).
                            const anyFilterActive =
                              activeTab !== "my_all_patients" ||
                              !!debouncedSearch ||
                              activeFilters.length > 0 ||
                              !!selectedCaseManager ||
                              filters.length > 0;
                            const isEmpty = filteredData.length === 0;

                            // Only show the full error state when we have NOTHING
                            // to show (initial load failed). A mid-pagination
                            // failure keeps the rows loaded so far + the inline
                            // "Retry" affordance above the table.
                            if (fetchError && isEmpty) {
                              return (
                                <EmptyState
                                  variant="error"
                                  action={{
                                    label: "Try again",
                                    onClick: refetchPatients,
                                  }}
                                />
                              );
                            }
                            if (isEmpty && anyFilterActive) {
                              return (
                                <EmptyState
                                  variant="filtered"
                                  action={{
                                    label: "Clear filters",
                                    onClick: () => {
                                      setNameSearch("");
                                      setActiveFilters([]);
                                      setFilters([]);
                                      setSelectedCaseManager("");
                                      setActiveTab("my_all_patients");
                                    },
                                  }}
                                />
                              );
                            }
                            if (isEmpty) {
                              return <EmptyState variant="no-data" />;
                            }
                            return (
                              <Table
                                columns={tableColumns}
                                data={filteredData}
                                disableInternalScroll
                                loading={loading}
                                isRowClickable={true}
                                onRowClick={(row) => handlePatientClick(row)}
                                defaultSortKey="name"
                                defaultSortDirection="asc"
                                primaryHeader={true}
                                onSort={(sortedData) => {
                                  // sortedData is the array after sorting in the table
                                  sessionStorage.setItem("_mdpl", JSON.stringify(sortedData?.map(p => p?.id)));
                                }}
                              />
                            );
                          })()}
                        </div>
                      </div>
                    )}

                  {/* Inactive Patients Table */}
                  {selectedProgram === "inactive_patients" && (
                    <div className={styles.table_container} >
                      <div className={styles.all_patients}>
                        <Table
                          columns={inactivePatientColumns}
                          data={filteredData}
                          disableInternalScroll
                          loading={false}
                          isRowClickable={false}
                          defaultSortKey="name"
                          defaultSortDirection="asc"
                          primaryHeader={true}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
      <BackToTop />
      <Modal
        title="Deactivation Reason"
        isOpen={deactivationReasonModal.isOpen}
        onClose={() => setDeactivationReasonModal({ isOpen: false, reason: "" })}
        width="480px"
        height="auto"
      >
        <p className={styles.deactivation_reason_modal_content}>
          {deactivationReasonModal.reason}
        </p>
      </Modal>
    </div>
  );
};

export default CareManagerDashboard;